export const widgetGalleryPlansIds = {
  'ImmoProperty LTD project': 'fc820593-e625-484f-b5a6-c7025816ed40',
  'Cottage community': '8c78317f-4d44-4671-a3e8-2b3545dadfb3',
  '3d offices Dark project': '92c040fb-21fc-4ca4-8501-e137de794ac6',
  'Palmbeach Con Jardin project': 'aa53b93a-5c79-415e-952c-17e3ab62f6cf',
  'Farmhouse project': '988d1259-a75d-4945-b439-04a0cb8840f3',
  'Hytte project': 'e619f2a8-b6d3-4a2f-bc81-f63a8d0b100a',
  'Richford project': 'ac8f87cb-a97b-42b9-a078-74c5c8db9726',
  'PrimProperty project': 'c1855bc7-b79a-4dc8-8f79-8d9de9236109',
  'Jaconda project': '5171bb0a-8246-4d35-91c7-ddb9a02c7289',
};
